/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
const downloadReportQuery = ({
  filter, url, exportFormat = 1,
}) => {
  // Transform keys to capitalize first letter
  const transformParamsKeys = Object.entries(filter).reduce(
    (prev, current) => ({
      ...prev,
      [current[0].charAt(0).toUpperCase() + current[0].substr(1)]: current[1],
    }),
    {},
  )

  // Filter out empty or null values
  const filterParams = Object.entries(transformParamsKeys).reduce(
    (memo, [key, value]) => (
      (value === '' || value === null) ? memo : (memo[key] = value, memo)
    ),
    {},
  )

  // Always include exportFormat in params
  filterParams.format = exportFormat

  // Build query string
  const params = new URLSearchParams(filterParams).toString()
  const searchURL = `${url}?${params}`

  return searchURL
}

export default downloadReportQuery
